<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Add team</strong>
          </div>
          <b-form>
          <b-form-group
            label="Team Name"
            label-for="teamName"
            :label-cols="3"
            :horizontal="true">
            <b-form-input id="teamName" type="text" autocomplete="name" v-model="teamData.name"></b-form-input>
          </b-form-group>
          <b-form-group
            label="Category"
            label-for="categorySelect"
            :label-cols="3"
            :horizontal="true">
            <b-form-select id="categorySelect"
              :plain="true"
              :options="getCategories(categories)"
              value="Select category..."
              v-model="currentCategory"
              v-on:change="setTeamCategory">
            </b-form-select>
          </b-form-group>
          <b-form-group
            label="Upload team logo"
            label-for="fileInput"
            :label-cols="3"
            :horizontal="true">
              <b-form-file accept="image/*" id="fileInput" :plain="true" v-model="teamData.logoFile"></b-form-file>
          </b-form-group>
         <div slot="footer">
            <b-row class="align-items-center">
              <b-col xl= "2" class="mb-3 mb-xl-0" >
                <b-button v-on:click="goBack" block variant="secondary">Back</b-button>
              </b-col>
              <b-col xl= "6" class="mb-3 mb-xl-0" >
                <b-button type="submit" v-if="!isEdit" v-on:click="confirmTeamButton" block variant="primary"><i class="fa fa-dot-circle-o"></i> Confirm Team</b-button>
                <b-button type="submit" v-if="isEdit" v-on:click="updateTeam" block variant="primary"><i class="fa fa-dot-circle-o"></i> Save Changes</b-button>
              </b-col>
              <b-col xl= "4" class="mb-3 mb-xl-0" >
                <b-alert variant="danger"
                        :show="!checkIfRemovable() && isEdit">
                        This team can't be removed while it has members
                </b-alert>
                <b-button v-if="checkIfRemovable()" v-on:click="removeTeam" block variant="danger"><i class="fa fa-ban"></i> Remove Team</b-button>
              </b-col>
            </b-row>
            <b-row class="align-items-center">
              <b-col xl= "6" class="mb-3 mb-xl-0" >
                <b-button type="submit" v-on:click="createTeamEvaluation" block variant="danger"><i class="fa fa-dot-circle-o"></i> Create Team Evaluation</b-button>
              </b-col>
            </b-row>
          </div>
          </b-form>
        </b-card>
      </b-col>
      <b-col md="3">
        <b-card v-if="previewLogoUrl != null">
          <div slot="header">
            <strong>Logo</strong>
          </div>
          <b-form-group>
            <b-img v-bind:src="previewLogoUrl" fluid alt="Responsive image" />
          </b-form-group>
        </b-card>
      </b-col>
      <b-col md="3">
        <b-card v-if="teamData.logoFile != null">
          <div slot="header">
            <strong>New logo</strong>
          </div>
          <b-form-group>
            <b-img v-bind:src="getLogoFileImage()" fluid alt="Responsive image" />
          </b-form-group>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" v-if="isEdit">
        <transition name="slide">
        <b-card :header="captionMembers">
          <b-form-checkbox-group stacked id="basicCustomCheckboxes">
            <b-table :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="membersArray" :fields="fieldsMembers" :current-page="currentPage" :per-page="perPage">
              <template slot="checkbox" slot-scope="data">
                <b-form-checkbox :value="data.item" v-model="membersSelected">
                </b-form-checkbox>
              </template>
              <template slot="name" slot-scope="data">
                <strong>{{data.item.val().name}}</strong>
              </template>
              <template slot="lastName" slot-scope="data">
                <strong>{{data.item.val().lastName}}</strong>
              </template>
              <template slot="role" slot-scope="data">
                <strong>{{data.item.val().role}}</strong>
              </template>
              <template slot="joined" slot-scope="data">
                <strong>{{new Date(data.item.val().joined).toGMTString()}}</strong>
              </template>
              <template slot="viewButton" slot-scope="data">
                <b-button :value="data.item" v-on:click="rowClicked(data.item)" block variant="primary">View</b-button>
              </template>
              
            </b-table>
          </b-form-checkbox-group>
          <nav>
            <b-pagination size="sm" :total-rows="membersArray.length" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            <b-row class="align-items-center">
              <b-col cols="6" class="mb-3 mb-xl-0" >
                <b-button v-on:click="addMemberButton" block variant="primary">Add Member</b-button>
              </b-col>
              <b-col cols="6" class="mb-3 mb-xl-0" >
                <b-button v-if="membersSelected.length > 0" v-on:click="removeMembersButton" block variant="danger">Remove Member(s)</b-button>
              </b-col>
              
          </b-row>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <b-modal title="Add a member" class="modal-primary" v-model="primaryModal" @ok="addNewMember">
      
      <b-form-group
            label="User role"
            label-for="roleSelect"
            :label-cols="3"
            :horizontal="true">
            <b-form-select id="roleSelect"
              :plain="true"
              :options="roleOptions"
              v-model="roleSelected"
              v-on:change="showRoleForm">
            </b-form-select>
          </b-form-group>
          <b-form-group
              label="Player"
              :label-cols="3"
              :horizontal="true"
              v-if="showPlayerSearch">
              <vue-bootstrap-typeahead 
              v-model="memberName"
              :data="playersArray"
              placeholder="Search by name ..."
              :serializer="s => s.val().name + ' ' + s.val().lastName"
              @hit="newMember = $event"/>
            </b-form-group>
            <b-form-group
              label="Coach"
              :label-cols="3"
              :horizontal="true"
              v-if="showCoachSearch">
              <vue-bootstrap-typeahead 
              v-model="memberName"
              :data="coachesArray"
              placeholder="Search by name ..."
              :serializer="s => s.val().name + ' ' + s.val().lastName"
              @hit="newMember = $event"/>
            </b-form-group>
    </b-modal>

  </div>
</template>

<script>
import _ from 'underscore'
import { db } from '@/config/devowqlo';
import { storage } from '@/config/devowqlo';
export default {
  name: 'forms',
  firebase: {
    teams: db.ref('teams'),
    categories: db.ref('categories'),
    teamChats: db.ref('teamChats'),
    counts: db.ref('counts'),
    users: db.ref('users')
  },
  props: {
    caption: {
      type: String,
      default: 'Team id'
    },
    captionMembers: {
      type: String,
      default: 'Members'
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isEdit: false,
      currentCategory: null,
      roleOptions: [
                {text: 'Select user role...',value: 'none'},
                {text: 'Coach',value: 'coach'},
                {text: 'Player',value: 'player'}
              ],
      roleSelected: null,
      showPlayerSearch: false,
      showCoachSearch: false,
      memberName: null,
      playersArray: [],
      coachesArray: [],
      newMember: null,
      primaryModal: false,
      teamData: {
        key: null,
        name: null,
        category: null,
        logoUrl: null,
        thumbLogoUrl: null,
        logoFile: null,
      },
      categoriesArray: [],
      fieldsMembers: [
        {key: 'checkbox', label: ''},
        {key: 'name'},
        {key: 'lastName'},
        {key: 'role'},
        {key: 'joined'},
        {key: 'viewButton', label: ''}
      ],
      membersArray: [],
      membersSelected: [],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      previewLogo: null,
      previewLogoUrl: null,
      evaluationAspects: null,
      goalkeeperAspect: null
    }
  },
  created() {
    if(this.$route.params.id){
      //this.$bindAsObject('members', db.ref('teamMembers/' + this.$route.params.id + '/members/'))
      this.teamData.key = this.$route.params.id
      this.setTeam()

   
    }
  },
  methods: {
    checkIfRemovable(){
      if(this.isEdit){
        if(this.membersArray.length == 0){
          return true
        }
      }
      return false
    },
    removeMembersButton(){
      this.membersSelected.forEach((member) => {

        const dateNow = Date.now()
        var newMemberVal = member.val()
        var newMemberKey = member.key
        var teamKey = this.teamData.key

        console.log(newMemberVal)

         var userGroup = ''
          if(newMemberVal.role == "player"){
            userGroup = "players"
          }else if(newMemberVal.role == "coach"){
            userGroup = "coaches"
          }

          //Get user node
          db.ref("users").child(userGroup).child(newMemberKey).
          once('value', (snap) => {
            newMemberVal = snap.val()

          });

        console.log(newMemberVal)

        //Remove players chat entry from userChats
        db.ref("userChats").child(newMemberKey).child('teamChats').child('playersTeamChats').child(teamKey).remove()

        //Remove user teams entry
        this.$firebaseRefs.users.child(userGroup).child(newMemberKey).child('teams').child(teamKey).remove()
        
        //Remove members entry from teamMembers
        db.ref("teamMembers").child(teamKey).child('members').child(newMemberKey).remove()

        //if player
        if(newMemberVal.role == "player"){

          var newMemberTutorId = Object.keys(newMemberVal.tutor)[0]

          //Remove parentsTeamChat from tutor
          //TODO: Mirar si hay otros hijos en ese equipo
          db.ref("teamChats").child(teamKey).child('parentsChat').
          once('value', (snap) => {
          var parentsChatId = snap.val().chatId

          db.ref("chatMembers").child(parentsChatId).child(newMemberTutorId).remove()
          
          
          });

          //Remove tutor parentsChat from teamChats
          db.ref("teamChats").child(teamKey).child('parentsChat').
          once('value', (snap) => {
          var parentsChatId = snap.val().chatId
          var tutorVal = Object.values(newMemberVal.tutor)[0]

          db.ref("chatMembers").child(parentsChatId).child(newMemberTutorId).remove() 
          
        });

          //Remove parentsTeamChat from userChats
          db.ref("userChats").child(newMemberTutorId).child('teamChats').child('parentsTeamChats').child(teamKey).remove()

          //Remove playersChat from teamChats
          db.ref("teamChats").child(teamKey).child('playersChat').
          once('value', (snap) => {
            var playersChatId = snap.val().chatId

            db.ref("chatMembers").child(playersChatId).child(newMemberKey).remove()

          });

          // Remove coach chat from userChats
          //TODO: Mirar resto de equipos si existe este mismo coach
          db.ref("teamMembers").child(teamKey).child('members').
          orderByChild("role").
          equalTo('coach').
          once('value', (snap) => {
            // console.log(snap)
            // console.log(snap.val())
              snap.forEach((childSnapshot) => {

                var coachMemberKey = childSnapshot.key;

                db.ref("userChats").child(newMemberKey).child('coachChats').child(coachMemberKey).remove()
              })
          })
          
          //Remove tutor child team 
          
          this.$firebaseRefs.users.child('parents').child(newMemberTutorId).child('childrenTeams').child(newMemberKey).child('teams').child(teamKey).remove()
        }else if(newMemberVal.role == "coach"){

          //Remove coachChats from players
          //TODO: Check if players exists on my other teams
          db.ref("teamMembers").child(teamKey).child('members').
          orderByChild("role").
          equalTo('player').
          once('value', (snap) => {

              snap.forEach((childSnapshot) => {

                var playerMemberKey = childSnapshot.key;

                db.ref("userChats").child(playerMemberKey).child('coachChats').child(newMemberKey).remove()
              })
          })

          //Remove parentsChat from teamChat
          db.ref("teamChats").child(teamKey).child('parentsChat').
          once('value', (snap) => {
            var parentsChatId = snap.val().chatId

            db.ref("chatMembers").child(parentsChatId).child(newMemberKey).remove()

          });
          
          //Remove playersChat from teamChat
          db.ref("teamChats").child(teamKey).child('playersChat').
          once('value', (snap) => {
            var playersChatId = snap.val().chatId

            db.ref("chatMembers").child(playersChatId).child(newMemberKey).remove()
          });
          
          //Remove parentsTeamChat from userChats
          db.ref("userChats").child(newMemberKey).child('teamChats').child('parentsTeamChats').child(teamKey).remove()

          
        }

        
      })
    },
    addMemberButton(){
      this.showPlayerSearch = false
      this.showCoachSearch = false
      this.roleSelected = this.roleOptions[0].value
      this.memberName = null
      this.primaryModal = true
    },
    updateTeam(){
      const dateNow = Date.now()

      if(this.teamData.logoFile != null){
        //Remove team logos
        storage.ref().child("TeamLogos").child(this.teamData.logoUrl).delete().catch(function(error) {
          // Handle any errors
        });

        storage.ref().child("TeamLogos").child(this.teamData.thumbLogoUrl).delete().catch(function(error) {
          // Handle any errors
        });

        console.log("Uploading picture...")
        const logoName = (+new Date()) + '-' + this.teamData.logoFile.name;
        const logoMetadata = { contentType: this.teamData.logoFile.type };
        const uploadTask = storage.ref().child("TeamLogos").child(logoName).put(this.teamData.logoFile, logoMetadata)
          .then(snapshot => snapshot.ref.getDownloadURL())
          .then(url => {
            var thumbLogoUrl = "thumb_" + logoName

            var teamModel = { 
              name: this.teamData.name,
              category: this.teamData.category,
              logoUrl: logoName,
              thumbLogoUrl: thumbLogoUrl,
              modified: dateNow
            }
            //1. Update team
            this.$firebaseRefs.teams.child(this.teamData.category).child(this.teamData.key).update(teamModel)

            //2. Update team matches
            db.ref("teamMatches").child(this.teamData.key)
            .once('value', (snap) => {
                snap.forEach((childSnapshot) => {
                  var childKey = childSnapshot.key;
                  db.ref("teamMatches").child(this.teamData.key).child(childKey).child("localTeam").child(this.teamData.key).update(teamModel)
                })
                //3. Success go back
                this.$router.go(-1)
            })
          })
      }else{
        var teamModel = { 
          name: this.teamData.name,
          category: this.teamData.category,
          modified: dateNow
        }

        var basicTeamModel = {
          name: this.teamData.name,
          category: this.teamData.category
        }

        var teamName = {
          name: this.teamData.name
        }
        //1. Update team
        this.$firebaseRefs.teams.child(this.teamData.category).child(this.teamData.key).update(teamModel)
        
        //2. Update team matches
          db.ref("teamMatches").child(this.teamData.key)
          .once('value', (snap) => {
              snap.forEach((childSnapshot) => {
                var childKey = childSnapshot.key;
                db.ref("teamMatches").child(this.teamData.key).child(childKey).child("localTeam").child(this.teamData.key).update(teamModel)
              })
              //3. Success go back
              this.$router.go(-1)
          })

          //3. Update team members
        db.ref("teamMembers").child(this.teamData.key)
          .child('members')
          .once('value', (snap) => {
              snap.forEach((childSnapshot) => {
                var childKey = childSnapshot.key;
                console.log("childsnap", childSnapshot.val())
                var childRole = childSnapshot.val().role

                if(childRole=="coach"){
                  db.ref("users").child("coaches").child(childKey).child("teams").child(this.teamData.key).update(basicTeamModel)

                  db.ref("userChats").child(childKey).child("teamChats").child("playersTeamChats").child(this.teamData.key).child("team").update(basicTeamModel)
                  db.ref("userChats").child(childKey).child("teamChats").child("parentsTeamChats").child(this.teamData.key).child("team").update(basicTeamModel)

                  db.ref("userChats").child(childKey).child("teamChats").child("playersTeamChats").child(this.teamData.key).update(teamName)
                  db.ref("userChats").child(childKey).child("teamChats").child("parentsTeamChats").child(this.teamData.key).update(teamName)
                }else{
                  db.ref("users").child("players").child(childKey).child("teams").child(this.teamData.key).update(basicTeamModel)
                  db.ref("userChats").child(childKey).child("teamChats").child("playersTeamChats").child(this.teamData.key).child("team").update(basicTeamModel)
                  db.ref("userChats").child(childKey).child("teamChats").child("playersTeamChats").child(this.teamData.key).update(teamName)
                }

              })

          })

              db.ref("teamMembers").child(this.teamData.key)
          .child('parents')
          .once('value', (snap) => {
              snap.forEach((childSnapshot) => {
                var childKey = childSnapshot.key;
                console.log("childsnap", childSnapshot.val())
                var childRole = childSnapshot.val().role


                db.ref("userChats").child(childKey).child("teamChats").child("parentsTeamChats").child(this.teamData.key).child("team").update(basicTeamModel)
                db.ref("userChats").child(childKey).child("teamChats").child("parentsTeamChats").child(this.teamData.key).update(teamName)

              })
              
              
          })

//3. Success go back
          this.$router.go(-1)
      }
    },
    removeTeam(){


      //Remove teamchats
      var teamKey = this.teamData.key
      this.$firebaseRefs.teamChats.child(teamKey).child('parentsChat').remove()
      this.$firebaseRefs.teamChats.child(teamKey).child('playersChat').remove()
      this.$firebaseRefs.teamChats.child(teamKey).child('onlyParentsChat').remove()

      //Remove team logos
      storage.ref().child("TeamLogos").child(this.teamData.logoUrl).delete().catch(function(error) {
        // Handle any errors
      });

      storage.ref().child("TeamLogos").child(this.teamData.thumbLogoUrl).delete().catch(function(error) {
        // Handle any errors
      });


      //Remove team
      db.ref('teams').child(this.teamData.category).child(teamKey).remove()

      var countRef = this.$firebaseRefs.counts.child('teamsCount').child('count')

      countRef.transaction(function(count) {
        if (count) {
          if(count > 0){
            count = count - 1;
          }
        }else{
          count = 0
        }
        return count;
      })

      this.$router.go(-1)

    },
    setTeam(){
      this.isEdit = true
      this.$firebaseRefs.teams.
          once('value', (mainSnap) => {

            mainSnap.forEach(categorySnap => {
              categorySnap.forEach(snap => {
                if(snap.key == this.teamData.key){
                  console.log(snap.val())
                  this.teamData.name = snap.val().name
                  this.teamData.category = snap.val().category
                  this.teamData.logoUrl = snap.val().logoUrl
                  this.teamData.thumbLogoUrl = snap.val().thumbLogoUrl
                }
              })
            }) 
          });

      storage.ref().child("TeamLogos").child(this.teamData.thumbLogoUrl).getDownloadURL().then((url) => {

        this.previewLogoUrl = url
      }).catch(function(error) {
        // Handle any errors
      });

      
      db.ref('teamMembers/' + this.$route.params.id + '/members/').on('value', (snapshot) =>{
        console.log(snapshot.val())
        this.membersArray = []
        snapshot.forEach(childSnapshot => {
          console.log(childSnapshot)
          this.membersArray.push(childSnapshot)
          // childSnapshot.forEach(matchSnapshot => {
          //   console.log(matchSnapshot.val())
          //   //this.membersArray.push(matchSnapshot.val())
          // })
          //this.membersArray.push(childSnapshot.val())
          //return childSnapshot.val()
        })
      })

       db.ref('teamMembers/' + this.$route.params.id + '/members/').on('child_removed', (snapshot) =>{
        console.log(snapshot.val())
        this.membersArray = []
        snapshot.forEach(childSnapshot => {
          console.log(childSnapshot)
          this.membersArray.push(childSnapshot)
          // childSnapshot.forEach(matchSnapshot => {
          //   console.log(matchSnapshot.val())
          //   //this.membersArray.push(matchSnapshot.val())
          // })
          //this.membersArray.push(childSnapshot.val())
          //return childSnapshot.val()
        })
      })

    },
    goBack() {
      this.$router.go(-1)
      // this.$router.replace({path: '/users'})
    },
    getLogoFileImage(){
        console.log(this.teamData.logoFile)
        var reader = new FileReader()
        reader.onload = (e) => {
          this.previewLogo = e.target.result
        }
        reader.readAsDataURL(this.teamData.logoFile)

        return this.previewLogo
    },
    getCategories(categories){
      var categoriesNamesArray = []
      var categoriesArray = []
      this.categoriesArray = []
      categories.forEach(element => {
        categoriesNamesArray.push(element.name)
        categoriesArray.push(element)

        if(element['.key'] == this.teamData.category){
          this.currentCategory = element.name
        }
      });
      this.categoriesArray = categoriesArray
      return categoriesNamesArray
    },
    setTeamCategory(value){
      this.categoriesArray.forEach(element => {
       if(element.name == value){
         this.teamData.category = element['.key']
       }
      });
    },
    confirmTeamButton () {
      this.uploadPictureFile()
    },
    uploadPictureFile(){
      console.log("Uploading picture...")
      const logoName = (+new Date()) + '-' + this.teamData.logoFile.name;
      const logoMetadata = { contentType: this.teamData.logoFile.type };
      const uploadTask = storage.ref().child("TeamLogos").child(logoName).put(this.teamData.logoFile, logoMetadata)
        .then(snapshot => snapshot.ref.getDownloadURL())
        .then(url => this.createTeamDb(logoName))
    },
    createTeamDb(logoName){
      
      console.log("Creating team on DB...")
       
      const thumbLogoUrl = 'thumb_' + logoName
      const dateNow = Date.now()

      var teamModel = { 
        name: this.teamData.name,
        category: this.teamData.category,
        logoUrl: logoName,
        thumbLogoUrl: thumbLogoUrl,
        created: dateNow,
        modified: dateNow
      }

      var teamKey = this.$firebaseRefs.teams.child(this.teamData.category).push(teamModel).key;
      //var teamRef = '/teams/' + this.teamData.category + '/' + teamKey
      var updates = {};

      //updates[teamRef] = teamModel

      //Create team chats
      var parentsChatKey = this.$firebaseRefs.teamChats.child(teamKey).child('parentsChat').push().key;
      var playersChatKey = this.$firebaseRefs.teamChats.child(teamKey).child('playersChat').push().key;
      var onlyParentsChatKey = this.$firebaseRefs.teamChats.child(teamKey).child('onlyParentsChat').push().key;

      var parentsChatRef = '/teamChats/' + teamKey + "/parentsChat"
      var playersChatRef = '/teamChats/' + '/' + teamKey + "/playersChat"
      var onlyParentsChatRef = '/teamChats/' + '/' + teamKey + "/onlyParentsChat"

      updates[parentsChatRef] = {
        chatId: parentsChatKey
      }
      updates[playersChatRef] = {
        chatId: playersChatKey
      }
      updates[onlyParentsChatRef] = {
        chatId: onlyParentsChatKey
      }

      db.ref().update(updates);

      this.teamData.name = '';
      this.teamData.category = '';
      this.teamData.logoFile = null

      var countRef = this.$firebaseRefs.counts.child('teamsCount').child('count')
      countRef.transaction(function(count) {
          if (count) {
            count = count + 1;
          }else{
            count = 1
          }
          console.log(count)
          return count;
      });

      this.$router.go(-1)

    },
    createTeamDependencies(teamId){
      //Create team chats
      var parentsChatKey = this.$firebaseRefs.teamChats.child(teamId).push().key;
      var playersChatKey = this.$firebaseRefs.teamChats.child(teamId).push().key;
      var onlyParentsChatKey = this.$firebaseRefs.teamChats.child(teamId).push().key;
      var teamChatsRef = this.$firebaseRefs.teamChats.child(teamId)
      var parentsChatRef = teamId + "/parentsChat"
      console.log(parentsChatRef)
      var playersChatRef = this.$firebaseRefs.teamChats.child(teamId)
      var onlyParentsChatRef = this.$firebaseRefs.teamChats.child(teamId)
      var updates = {};
      updates[parentsChatRef] = {
        chatId: parentsChatKey
      }
      // updates[teamChatsRef + "/playersChat"] = {
      //   chatId: playersChatKey
      // }
      // updates[teamChatsRef + "/onlyParentsChat"] = {
      //   chatId: onlyParentsChatRef
      // }
      this.$firebaseRefs.teamChats.update(updates);
      this.$router.go(-1)
    },
    memberNameChanged(value) {
      if(this.showPlayerSearch){
        this.playersArray = []
        var filteredArray = []

        /**
        *  Search ignore uppercase/ lowercase
        */  
        // 1. Search by name
        this.$firebaseRefs.users.child('players').
          orderByChild("name").
          startAt(this.memberName.toUppercase).
          endAt(this.memberName.toLowerCase+"\uf8ff").
          once('value', function(snap) {
            // console.log(snap.val())
              snap.forEach(function (childSnapshot) {
                //console.log(childSnapshot)
                var value = childSnapshot.val();
                filteredArray.push(childSnapshot)
              });
          });
          // 2. mod local data
          this.playersArray = filteredArray
      }else if(this.showCoachSearch){
        this.coachesArray = []
        var filteredArray = []

        /**
         *  Search ignore uppercase/ lowercase
         */
        this.$firebaseRefs.users.child('coaches').
          orderByChild("name").
          startAt(this.memberName.toUppercase).
          endAt(this.memberName.toLowerCase+"\uf8ff").
          once('value', function(snap) {
            // console.log(snap)
            // console.log(snap.val())
              snap.forEach(function (childSnapshot) {
                var value = childSnapshot.val();
                filteredArray.push(childSnapshot)
              });
          });
          this.coachesArray = _.uniq(filteredArray)
      }
    },
    
    showRoleForm(value){
      console.log(value);
      if(value == "coach"){
        console.log("Coachselected")
        this.showPlayerSearch = false
        this.showCoachSearch = true
      }else if(value == "player"){
        console.log("Player selected")
        this.showPlayerSearch = true
        this.showCoachSearch = false
      }else{
        console.log("None selected")
        this.showPlayerSearch = false
        this.showCoachSearch = false
      }
    },
    rowClicked (user) {
      console.log(user)
      const userLink = `/users/` + user.key  + '&&' + user.val().role
      this.$router.push({path: userLink})
      // :to="{ name: 'Edit', params: {id: item['.key']} }"
    },
    addNewMember(){
      const dateNow = Date.now()
      var newMemberVal = this.newMember.val()
      var newMemberKey = this.newMember.key
      var teamKey = this.$route.params.id

      console.log("New member val", newMemberVal)

      var position = ""
      if(newMemberVal.position != null){
        position = newMemberVal.position
      }
      
      var memberModel = { 
        name: newMemberVal.name,
        lastName: newMemberVal.lastName,
        gender: newMemberVal.gender,
        country: newMemberVal.country,
        birthdate: newMemberVal.birthdate,
        pictureUrl: newMemberVal.pictureUrl,
        thumbPictureUrl: newMemberVal.thumbPictureUrl,
        role: newMemberVal.role,
        position: position,
        joined: dateNow
      }

      var teamSnap = null
      this.$firebaseRefs.teams.child(this.teamData.category).child(this.teamData.key).
          once('value', (snap) => {
           
              if(snap.key == teamKey){
                 teamSnap = snap
                var teamSnapVal = teamSnap.val()

                var teamModel = { 
                  name: teamSnapVal.name,
                  category: teamSnapVal.category,
                  logoUrl: teamSnapVal.logoUrl,
                  thumbLogoUrl: teamSnapVal.thumbLogoUrl
                }

                var userGroup = ''
                if(newMemberVal.role == "player"){
                  userGroup = "players"
                }else if(newMemberVal.role == "coach"){
                  userGroup = "coaches"
                }
                //Create team member
                db.ref("teamMembers").child(teamKey).child('members').child(newMemberKey).set(memberModel)

                //Create user team
                this.$firebaseRefs.users.child(userGroup).child(newMemberKey).child('teams').child(teamKey).set(teamModel)



                    

                //Add playersTeamChat
                db.ref("teamChats").child(teamKey).child('playersChat').
                  once('value', (snap) => {
                    var playersChatId = snap.val().chatId

                    var lastMessageModel = {
                      content: " ",
                      viewed: true
                    }

                    var playersChatModel = teamModel
                    playersChatModel.chat = playersChatId
                    playersChatModel.lastMessage = lastMessageModel

                    db.ref("userChats").child(newMemberKey).child('teamChats').child('playersTeamChats').child(teamKey).set(playersChatModel)

                })
                //if player
                if(newMemberVal.role == "player"){
                  // NEW!!
                  this.dependenciesAddMemberPlayer(this.teamData.key, memberModel, newMemberKey)

                  console.log(newMemberVal.tutor)
                  console.log(Object.keys(newMemberVal.tutor)[0])
                  console.log(Object.values(newMemberVal.tutor)[0])

                  var newMemberTutorId = Object.keys(newMemberVal.tutor)[0]
                  this.$firebaseRefs.users.child('parents').child(newMemberTutorId).child('childrenTeams').child(newMemberKey).child('teams').child(teamKey).set(teamModel)

                  var newMemberTutorVal = Object.values(newMemberVal.tutor)[0]
                  var parentMemberModel = { 
                    name: newMemberTutorVal.name,
                    lastName: newMemberTutorVal.lastName,
                    birthdate: newMemberTutorVal.birthdate,
                    pictureUrl: newMemberTutorVal.pictureUrl,
                    thumbPictureUrl: newMemberTutorVal.thumbPictureUrl,
                    role: "parent",
                    joined: dateNow
                  }

                  //Create parent member
                  console.log("adding parent member")
                  db.ref("teamMembers").child(teamKey).child('parents').child(newMemberTutorId).set(parentMemberModel)

                  //Add coach chat
                   // 1. Add coach chat
                  // 2. Notify to coaches
                  db.ref("teamMembers").child(teamKey).child('members').
                    orderByChild("role").
                    equalTo('coach').
                    once('value', (snap) => {
                      // console.log(snap)
                      // console.log(snap.val())
                        snap.forEach((childSnapshot) => {

                          var coachMemberKey = childSnapshot.key;

                          var lastMessageModel = {
                            content: " ",
                            viewed: true
                          }

                          var coachChatModel = { 
                            name: childSnapshot.val().name,
                            lastName: childSnapshot.val().lastName,
                            pictureUrl: childSnapshot.val().pictureUrl,
                            thumbPictureUrl: childSnapshot.val().thumbPictureUrl,
                            lastMessage: lastMessageModel
                          }
                          // 1. Add coach chat
                          db.ref("userChats").child(newMemberKey).child('coachChats').child(coachMemberKey).set(coachChatModel) 

                          var modelTeamToSave = {}
                          modelTeamToSave[teamKey] = teamModel
                          // 2. Notify to coaches 
                          var notificationModel = {
                            type: 'newMember', 
                            typeId: "", 
                            typeName: "", 
                            userId: newMemberKey, 
                            userName: memberModel.name, 
                            action: "joined", 
                            timestamp: Date.now(),
                            team: modelTeamToSave,
                            viewed: false
                          }
                          console.log("<-- NOTIFY TO COACH TEAM");
                          
                          console.log(notificationModel);
                          
                          db.ref('userNotifications').child(coachMemberKey).child('notifications').push(notificationModel)
                        })
                    })

                  //Add to playersChat
                  db.ref("teamChats").child(teamKey).child('playersChat').
                    once('value', (snap) => {
                      var playersChatId = snap.val().chatId

                      var chatMemberModel = {
                        name: newMemberVal.name,
                        lastName: newMemberVal.lastName
                      }

                      db.ref("chatMembers").child(playersChatId).child(newMemberKey).set(chatMemberModel) 

                    });

                  //Add tutor to parentsChat
                  db.ref("teamChats").child(teamKey).child('parentsChat').
                  once('value', (snap) => {
                    var parentsChatId = snap.val().chatId
                    var tutorVal = Object.values(newMemberVal.tutor)[0]
                    var chatMemberModel = {
                      name: tutorVal.name,
                      lastName: tutorVal.lastName
                    }

                    db.ref("chatMembers").child(parentsChatId).child(newMemberTutorId).set(chatMemberModel) 

                    //Add parentsTeamChat to tutor
                    // TODO: revisar chat parents
                    var lastMessageModel = {
                      content: " ",
                      viewed: true
                    }
                    var parentChatModel = teamModel
                    parentChatModel.chat = parentsChatId
                    parentChatModel.lastMessage = lastMessageModel
                    db.ref("userChats").child(newMemberTutorId).child('teamChats').child('parentsTeamChats').child(teamKey).set(parentChatModel)
                  });

                  

                }else if(newMemberVal.role == "coach"){
                  //Add coach chat
                  db.ref("teamMembers").child(teamKey).child('members').
                    orderByChild("role").
                    equalTo('player').
                    once('value', (snap) => {
                      // console.log(snap)
                      // console.log(snap.val())
                        snap.forEach((childSnapshot) => {

                          var playerMemberKey = childSnapshot.key;

                          var lastMessageModel = {
                            content: " ",
                            viewed: true
                          }

                          var coachChatModel = { 
                            name: memberModel.name,
                            lastName: memberModel.lastName,
                            pictureUrl: memberModel.pictureUrl,
                            thumbPictureUrl: memberModel.thumbPictureUrl,
                            lastMessage: lastMessageModel
                          }
                          db.ref("userChats").child(playerMemberKey).child('coachChats').child(newMemberKey).set(coachChatModel)
                        })
                    })


                  //Add to playersChat
                  db.ref("teamChats").child(teamKey).child('playersChat').
                    once('value', (snap) => {
                      var playersChatId = snap.val().chatId

                      var chatMemberModel = {
                        name: newMemberVal.name,
                        lastName: newMemberVal.lastName
                      }
                      db.ref("chatMembers").child(playersChatId).child(newMemberKey).set(chatMemberModel) 
                    });
                  //Add to parentsChat
                  db.ref("teamChats").child(teamKey).child('parentsChat').
                    once('value', (snap) => {
                      var parentsChatId = snap.val().chatId
                      var chatMemberModel = {
                        name: newMemberVal.name,
                        lastName: newMemberVal.lastName
                      }
                      db.ref("chatMembers").child(parentsChatId).child(newMemberKey).set(chatMemberModel) 
                      //Add parentsTeamChat to tutor
                      // TODO: revisar chat parents
                      var parentChatModel = teamModel
                      parentChatModel.chat = parentsChatId
                      db.ref("userChats").child(newMemberKey).child('teamChats').child('parentsTeamChats').child(teamKey).set(parentChatModel)
                   });

                  //Add coach chat to players
                  db.ref("teamMembers").child(teamKey).child('members').
                    orderByChild("role").
                    equalTo('player').
                    once('value', (snap) => {
                        snap.forEach((childSnapshot) => {

                          var lastMessageModel = {
                            content: " ",
                            viewed: true
                          }
                          
                          var playerMemberKey = childSnapshot.key;
                          var coachChatModel = { 
                            name: newMemberVal.name,
                            lastName: newMemberVal.lastName,
                            pictureUrl: newMemberVal.pictureUrl,
                            thumbPictureUrl: newMemberVal.thumbPictureUrl,
                            lastMessage: lastMessageModel
                          }

                          db.ref("userChats").child(playerMemberKey).child('coachChats').child(newMemberKey).set(coachChatModel) 
                        })
                    })
                }

              }
             
          })

    },

    dependenciesAddMemberPlayer(teamKey, member, newMemberKey) {

      console.log("<-- dependenciesAddMember · Player team key: " + teamKey + "   member key: " + newMemberKey );
      
        const dateNow = Date.now()
        var userSimpleModel = {
              name: member.name,
              lastName: member.lastName,
              thumbPictureUrl: member.thumbPictureUrl,
            }

         // 1. Buscar los proximos partidos a partir de la fecha actual
         db.ref("teamMatches").child(teamKey).
          orderByChild("timeStamp")
          .startAt(dateNow )
          .once('value', (snap) => {

              // 1.1 Recorremos los partidos encontrados
              snap.forEach((childSnapshot) => {

                var matchKey = childSnapshot.key;
                console.log("match: " + matchKey + " ·   "+ childSnapshot.val().date + " - "  +  childSnapshot.val().hour  );
                
                // 1.2 Añadimos el usuario a la lista de available del partido
                db.ref('matchControl').child('viewControl').child(teamKey).child(matchKey).child('pending').child(newMemberKey).set(userSimpleModel)
                db.ref('matchControl').child('availabilityControl').child(teamKey).child(matchKey).child('available').child(newMemberKey).set(userSimpleModel)
              })
          })

        // 2. Buscar los proximos entrenamientos a partir de la fecha actual
        db.ref("teamTrainings").child(teamKey)
          .orderByChild("timeStamp")
          .startAt(dateNow )
          .once('value', (snap) => {

              // 2.1 Recorremos los entrenamientos encontrados
              snap.forEach((childSnapshot) => {

                var trainingKey = childSnapshot.key;
                console.log("training: " + trainingKey + " ·   "+ childSnapshot.val().date + " - "  +  childSnapshot.val().hour  );

                // 2.2 Añadimos el usuario a la lista de available del entrenamiento
                db.ref('trainingControl').child('viewControl').child(teamKey).child(trainingKey).child('pending').child(newMemberKey).set(userSimpleModel)
                db.ref('trainingControl').child('availabilityControl').child(teamKey).child(trainingKey).child('available').child(newMemberKey).set(userSimpleModel)
              })
          })
  },
  createTeamEvaluation(){


    console.log("Creating Team Evaluation")
    var teamKey = this.$route.params.id

    //1. Get keys for each evaluation
    //var teamEvaluationFallKey = db.ref("teamEvaluation").child(teamKey).push().key;
    //var teamEvaluationWinterKey = db.ref("teamEvaluation").child(teamKey).push().key;
    var teamEvaluationSpringKey = db.ref("teamEvaluation").child(teamKey).push().key;

    /*2. Create each evaluation*/
    /*var teamEvaluationFall = {
      name: "Fall",
      index: 0
    }

    var teamEvaluationWinter = {
      name: "Winter",
      index: 1
    }*/

    var teamEvaluationSpring = {
      name: "Spring",
      index: 0
    }

    db.ref("teamEvaluation").child(teamKey).child(teamEvaluationSpringKey).set(teamEvaluationSpring)
    /*2. ---------------- */

    //3. Create evaluation aspects
    console.log("Creating Aspects")
    this.createEvaluationAspects()

    console.log("Creating for each player")
    db.ref("teamMembers").child(teamKey)
          .child('members')
          .once('value', (snap) => {
              snap.forEach((childSnapshot) => {
                var childKey = childSnapshot.key;
                console.log("childsnap", childSnapshot.val())
                var childRole = childSnapshot.val().role
                var childPos = childSnapshot.val().position

                var localEvaluationAspects = [...this.evaluationAspects]
                if(childRole=="player"){

                  if(childPos == "Goalkeeper"){
                    localEvaluationAspects.push(this.goalkeeperAspect)
                  }


                  db.ref("teamEvaluation").child(teamKey).child(teamEvaluationSpringKey).child("toDo").child(childKey).set(childSnapshot.val())
                  db.ref("teamEvaluation").child(teamKey).child(teamEvaluationSpringKey).child("toDo").child(childKey).child("evaluationAspects").set(localEvaluationAspects)
                  //.child("toDo").child("teams").child(this.teamData.key).update(basicTeamModel)
                }

              })

          })


    
  },
  createEvaluationAspects(){

    /*-----PSYCHO--------*/

    //Create Psycho questions
    var questionsSubAspectPsycho = [
      {
        name: "Capacity to interact with his teammates",
        index: 0
      },
      {
        name: "Listens to Coach",
        index: 1
      },
      {
        name: "Level of Focus",
        index: 2
      },
      {
        name: "Leadership",
        index: 3
      },
      {
        name: "Communication with the coach",
        index: 4
      },
      {
        name: "Positive attitude",
        index: 5
      }
    ]

    //Create Psycho sub aspects
    var evaluationSubAspectsPsycho = [
      {
        name: "Psychosocial Aspects",
        index: 0,
        questions: questionsSubAspectPsycho
      }
    ]

    /*------------------*/

    /*-----TECHNICAL----*/

    //Create Technical-Control Passing questions
    var questionsSubAspectControlPassing = [
      {
        name: "Uses the Proper Part of Foot",
        index: 0
      },
      {
        name: "Directional Control",
        index: 1
      },
      {
        name: "Peripherial Vision",
        index: 2
      },
      {
        name: "Takes Initiative",
        index: 3
      },
      {
        name: "One-Touch Passing",
        index: 4
      },
      {
        name: "Uses Weak Foot",
        index: 5
      }
    ]

    //Create Technical-Running with the ball questions
    var questionsSubAspectRunningBall = [
      {
        name: "Uses the Proper Part of Foot",
        index: 0
      },
      {
        name: "Keeps Vision of the Field and the Ball",
        index: 1
      },
      {
        name: "Range of control",
        index: 2
      },
      {
        name: "Speed",
        index: 3
      },
      {
        name: "Uses Weak Foot",
        index: 4
      }
    ]

    //Create Technical-Running with the ball questions
    var questionsSubAspectDribbling = [
      {
        name: "Uses the Proper Part of Foot",
        index: 0
      },
      {
        name: "Keeps Vision of the Field and the Ball",
        index: 1
      },
      {
        name: "Feints and Body Fakes",
        index: 2
      },
      {
        name: "Using Outside Foot (away from defender)",
        index: 3
      },
      {
        name: "Acceleration",
        index: 4
      },
      {
        name: "Keeping the Ball Under Pressure",
        index: 5
      },
      {
        name: "Uses Weak Foot",
        index: 6
      },
    ]

    //Create Technical-Running with the ball questions
    var questionsSubAspectShooting = [
      {
        name: "Uses the Proper Part of Foot",
        index: 0
      },
      {
        name: "Varies Shot Depending on Situation",
        index: 1
      },
      {
        name: "Accuracy",
        index: 2
      },
      {
        name: "Power",
        index: 3
      },
      {
        name: "Uses Weak Foot",
        index: 4
      }
    ]

    var evaluationSubAspectsTechnical = [
      {
        name: "Control and Passing",
        index: 0,
        questions: questionsSubAspectControlPassing
      },
      {
        name: "Running with the ball",
        index: 1,
        questions: questionsSubAspectRunningBall
      },
      {
        name: "Dribbling (1V1)",
        index: 2,
        questions: questionsSubAspectDribbling
      },
      {
        name: "Shooting",
        index: 3,
        questions: questionsSubAspectShooting
      }
    ]

    /*------------------*/

    /*-----TACTICAL-----*/

    //Create Technical-Running with the ball questions
    var questionsSubAspectAttacking = [
      {
        name: "Identifies Free Players",
        index: 0
      },
      {
        name: "Makes Decisions (to pass or dribble)",
        index: 1
      },
      {
        name: "Playing of the ball - Good vision of the surrondings",
        index: 2
      },
      {
        name: "Playing of the ball - Positioning on the field",
        index: 3
      },
      {
        name: "Playing of the ball - Taking initiative",
        index: 4
      },
      {
        name: "Understanding of the style of play",
        index: 5
      },
      {
        name: "Good communication when the team is attacking",
        index: 6
      },
    ]

    //Create Technical-Running with the ball questions
    var questionsSubAspectDefending = [
      {
        name: "Understanding of the movements based on the zone",
        index: 0
      },
      {
        name: "Understanding of different ways to apply pressure",
        index: 1
      },
      {
        name: "Quick reaction to Attack-Defending Transition",
        index: 2
      },
      {
        name: "Good communication when the team is defending",
        index: 3
      }
    ]

    var evaluationSubAspectsTactical = [
      {
        name: "Attacking",
        index: 0,
        questions: questionsSubAspectAttacking
      },
      {
        name: "Defending",
        index: 1,
        questions: questionsSubAspectDefending
      }
    ]

    /*------------------*/

    /*----ATTENDANCE----*/

        //Create Psycho questions
    var questionsSubAspectAttendance = [
      {
        name: "Practice Attendance",
        index: 0
      },
      {
        name: "Punctuality",
        index: 1
      },
      {
        name: "Communicates when not attending",
        index: 2
      }
    ]

    //Create Psycho sub aspects
    var evaluationSubAspectsAttendance = [
      {
        name: "Attendance",
        index: 0,
        questions: questionsSubAspectAttendance
      }
    ]

    /*------------------*/

    /*----GOALKEEPER----*/

    //Create Psycho questions
    var questionsSubAspectGoalkeeper = [
      {
        name: "Hand Position",
        index: 0
      },
      {
        name: "Footwork (quickness to adjust position)",
        index: 1
      },
      {
        name: "Reflexes",
        index: 2
      },
      {
        name: "1v1 Situations",
        index: 3
      },
      {
        name: "Distribution with hands",
        index: 4
      },
      {
        name: "Distribution with feet",
        index: 5
      },
      {
        name: "Flighted Balls",
        index: 6
      }
    ]

    //Create Psycho sub aspects
    var evaluationSubAspectsGoalkeeper = [
      {
        name: "Goalkeeper",
        index: 0,
        questions: questionsSubAspectAttendance
      }
    ]

    /*------------------*/

    //Goalkeeper aspect
    this.goalkeeperAspect = {
      name: "Goalkeeper",
      index: 4,
      color: "#ff6d00",
      iconName: "ic_gloves",
      evaluationSubAspects: evaluationSubAspectsGoalkeeper
    }

    /*Create each evaluation aspect*/
    this.evaluationAspects = [
      {
        name: "Psychosocial Aspects",
        index: 0,
        color: "#665197",
        iconName: "ic_brain",
        evaluationSubAspects: evaluationSubAspectsPsycho
      },
      {
        name: "Technical Aspects",
        index: 1,
        color: "#ffc521",
        iconName: "ic_settings",
        evaluationSubAspects: evaluationSubAspectsTechnical
      },
      {
        name: "Tactical Aspects",
        index: 2,
        color: "#81b46a",
        iconName: "ic_training",
        evaluationSubAspects: evaluationSubAspectsTactical
      },
      {
        name: "Attendance",
        index: 3,
        color: "#51b1ca",
        iconName: "ic_board",
        evaluationSubAspects: evaluationSubAspectsAttendance
      }
    ]

    
    /*---------------- */
  }
  },
  watch: {

    memberName: _.debounce(function(mem) { this.memberNameChanged(mem) }, 500)

  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
